import { Button } from '@alto/design-system';
import * as React from 'react';
import { push } from 'react-router-redux';
import { COMMS_CHANNEL, IMG_ALT_TEXTS } from '~shared/constants';
import { useDispatchShared } from '~shared/store';
import { CommsVerificationCard } from './CommsVerificationCard';
import { Image } from '~web/components/Image';
import checkmark from '~web/images/verifiedCheckmark@2x.png';

export type Props = {
  readonly commsChannel: string;
  readonly authorized: boolean;
};

export const CommsVerificationSuccess = ({ authorized, commsChannel }: Props) => {
  const dispatch = useDispatchShared();

  const navigateToNextRoute = () => {
    if (authorized) {
      dispatch(
        push({
          pathname: '/prescriptions',
        }),
      );
    } else {
      // TODO: Get app store route
      dispatch(
        push({
          pathname: '/',
        }),
      );
    }
  };

  return (
    <CommsVerificationCard
      headerIcon={
        <Image
          sidebar
          src={checkmark}
          alt={IMG_ALT_TEXTS.greenCheckmark}
        />
      }
      title={`${COMMS_CHANNEL[commsChannel as keyof typeof COMMS_CHANNEL]} verified!`}
    >
      <Button
        onPress={navigateToNextRoute}
        label="Continue to Alto"
        accessibilityLabel="Continue to Alto"
        width="full"
      />
    </CommsVerificationCard>
  );
};
